import script from "./CardPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardPreview.vue?vue&type=script&setup=true&lang=ts"

import "./CardPreview.vue?vue&type=style&index=0&id=92d60fd4&scoped=true&lang=scss"

import exportComponent from "/home/dorian/programy/vue-draft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92d60fd4"]])

export default __exports__